import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import EmptyListState from '../components/EmptyListState'
import Footer from '../components/Footer'
import PageWrapper from '../components/PageWrapper'
import PresetTourCard from '../components/presets/PresetTourCard'
import PageSeo from '../components/seo/PageSeo'
import SideMenu from '../components/SideMenu'
import { fetchFirestoreList } from '../utils/fetchFirestoreList'

export default function Trips() {
  const [tours, setTours] = useState([])
  const [loadError, setLoadError] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    ;(async () => {
      const { items, error } = await fetchFirestoreList('Tours')
      if (!active) return
      setTours(items)
      setLoadError(error)
      setLoading(false)
    })()
    return () => {
      active = false
    }
  }, [])

  return (
    <motion.div
      initial={{ y: -150, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <PageSeo h1="Trips Schedule" />
      <SideMenu pageWrapId={'outer-page-wrapper'} outerContainerId={'inner-page-wrapper'} />
      <PageWrapper
        name={'Trips'}
        display={
          <h1 className="txt-big">
            <strong>
              <span className="text-success">T</span>
              <span className="text-warning">r</span>
              <span className="text-danger">i</span>
              <span className="text-success">p</span>
              <span className="text-warning">s</span> Schedule
            </strong>
          </h1>
        }
      >
        <span className="txt-cream txt-shadow">
          Reggae Wheels trips are a social way to visit north-coast destinations from Discovery Bay, Montego Bay, and Ocho Rios.
        </span>
      </PageWrapper>

      <Container style={{ marginBottom: '20vh' }}>
        {loading ? (
          <p className="text-center text-cream" role="status">Loading trips…</p>
        ) : loadError ? (
          <EmptyListState
            title="Trips unavailable right now"
            message="We could not load the trips schedule."
            permissionHint="Firestore rules may need to be deployed to allow public read access to Tours."
            actionTo="/about-us"
            actionLabel="About Reggae Wheels"
          />
        ) : tours.length === 0 ? (
          <EmptyListState
            title="No trips scheduled"
            message="New departures will appear here when they are published."
            actionTo="/tours"
            actionLabel="Browse tours"
          />
        ) : (
          <Row>
            {tours.map((tour) => (
              <Col key={tour.id} className="col-lg-4 col-md-6 col-sm-12 mb-3">
                <PresetTourCard tour={tour} />
              </Col>
            ))}
          </Row>
        )}
      </Container>

      <Footer />
    </motion.div>
  )
}
